// ====================================================================================
// --- Arquivo: src/index.js ---
// ====================================================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installModernAlert } from './utils/modernAlert';

// Avisos modernos no lugar da caixa cinza do alert() nativo
installModernAlert();

// Em produção, silencia logs de depuração (podem expor dados clínicos no console).
// Avisos e erros continuam visíveis.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
